/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScriptExecutionTargetStateEnum = 'QUEUED' | 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';

export const ScriptExecutionTargetStateEnum = {

    QUEUED: 'QUEUED' as ScriptExecutionTargetStateEnum,

    IN_PROGRESS: 'IN_PROGRESS' as ScriptExecutionTargetStateEnum,

    SUCCESS: 'SUCCESS' as ScriptExecutionTargetStateEnum,

    FAILED: 'FAILED' as ScriptExecutionTargetStateEnum
};

